<template>
    <div v-if="simpleText">
        {{value}}
    </div>
    <div v-else class="table-field-input">
        <v-text-field
            dense
            solo
            :disabled="disabled"
            :value="value"
            @input="changeHandler"
            class="elevation-0"
            :type="type ? type : 'text'"
            :class="!!error ? 'error' : ''"
            min="0"
        >

        </v-text-field>
        <div class="table-field-input_error-tooltip" v-show="error">
            <v-tooltip top color="#000" >
                <template v-slot:activator="{ on }">
                    <v-icon small v-on="on" color="red">mdi-information</v-icon>
                </template>
                <div>
                    {{error}}
                </div>
            </v-tooltip>
        </div>
    </div>

</template>

<script>
    export default {
        name: 'stockTableField',
        props: ['simpleText', 'value', 'error', 'disabled', 'type'],
        model: {
            prop: 'value',
            event: 'input'
        },
        data: () => ({
        }),
        methods: {
            changeHandler (val) {
                this.$emit('input', val)
            }
        }
    }
</script>

<style lang="scss">
    .table-field-input {
        position: relative;
        &_error {
            font-size: 11px;
            position: absolute;
            width: 100%;
            bottom: 0;
            left: 0;
        }
        &_error-tooltip {
            position: absolute;
            top: 50%;
            left: -20px;
            transform: translateY(-55%);
        }
    }
</style>
